import api from './api';

const promoService = {
  // Promo methods
  async getAllPromos(params = {}) {
    try {
      const response = await api.get('/admin/promo', { params });
      return response;
    } catch (error) {
      console.error('Error fetching promos:', error);
      throw error;
    }
  },

  async getPromo(promoId) {
    try {
      const response = await api.get(`/admin/promo/${promoId}`);
      return response;
    } catch (error) {
      console.error('Error fetching promo:', error);
      throw error;
    }
  },

  async addEditPromo(payload) {
    try {
      const response = await api.post('/admin/promo/add-edit', payload);
      return response;
    } catch (error) {
      console.error('Error adding/editing promo:', error);
      throw error;
    }
  },

  // Promo Campaign methods
  async getAllCampaigns(params = {}) {
    try {
      const response = await api.get('/admin/promo-campaign/', { params });
      return response;
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      throw error;
    }
  },

  async getCampaignsWithPromos(pcId) {
    try {
      const response = await api.get(`/admin/promo-campaign/${pcId}`);
      return response;
    } catch (error) {
      console.error('Error fetching campaign with promos:', error);
      throw error;
    }
  },

  async addEditCampaigns(payload) {
    try {
      const response = await api.post('/admin/promo-campaign/add-edit', payload);
      return response;
    } catch (error) {
      console.error('Error adding/editing campaign:', error);
      throw error;
    }
  },

  async addPromosForCampaigns(pcId, count, payload) {
    try {
      const response = await api.post(`/admin/promo-campaign/${pcId}/add-promos/${count}`, payload);
      return response;
    } catch (error) {
      console.error('Error adding promos for campaign:', error);
      throw error;
    }
  },

  async setCampaignPromoStatus(pcId, promoId, status) {
    try {
      const response = await api.post(`/admin/promo-campaign/${pcId}/promo/${promoId}/${status}`);
      return response;
    } catch (error) {
      console.error('Error setting campaign promo status:', error);
      throw error;
    }
  },

  // Razorpay Offer methods
  async getAllRzpOffers(params = {}) {
    try {
      const response = await api.get('/admin/promo-rzp-offer', { params });
      return response;
    } catch (error) {
      console.error('Error fetching RZP offers:', error);
      throw error;
    }
  },

  async getRzpOffer(rzpOfferId) {
    try {
      const response = await api.get(`/admin/promo-rzp-offer/${rzpOfferId}`);
      return response;
    } catch (error) {
      console.error('Error fetching RZP offer:', error);
      throw error;
    }
  },

  async saveRzpOffer(payload) {
    try {
      const response = await api.post('/admin/promo-rzp-offer', payload);
      return response;
    } catch (error) {
      console.error('Error saving RZP offer:', error);
      throw error;
    }
  }
};

export default promoService;
